import Hls from 'hls.js';

export interface QualityLevel {
  index: number;
  height: number;
  bitrate: number;
  label: string;
}

export class StreamForgeHLS {
  private hls: Hls | null = null;
  private video: HTMLVideoElement;
  private onLevelsReady: ((levels: QualityLevel[]) => void) | null = null;

  constructor(video: HTMLVideoElement) {
    this.video = video;
  }

  public load(url: string) {
    if (Hls.isSupported()) {
      if (this.hls) this.hls.destroy();
      
      this.hls = new Hls({
        capLevelToPlayerSize: true,
        autoStartLoad: true,
      });
      
      this.hls.loadSource(url);
      this.hls.attachMedia(this.video);
      
      this.hls.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
        console.log('HLS Manifest Parsed');
        const levels: QualityLevel[] = data.levels.map((level, i) => ({
          index: i,
          height: level.height,
          bitrate: level.bitrate,
          label: `${level.height}p`,
        }));
        if (this.onLevelsReady) this.onLevelsReady(levels);
      });
    } else if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
      this.video.src = url;
    }
  }

  public setQuality(levelIndex: number) {
    if (this.hls) {
      this.hls.currentLevel = levelIndex; // -1 = auto
    }
  }

  public getCurrentLevel(): number {
    return this.hls?.currentLevel ?? -1;
  }

  public onQualityLevels(cb: (levels: QualityLevel[]) => void) {
    this.onLevelsReady = cb;
  }

  public destroy() {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
  }
}
